import { Extension } from '@tiptap/core';
import { createCustomDocumentContentPlugin } from './custom-document-content-plugin';

export const CustomDocument = Extension.create({
    name: 'customDocument',

    addProseMirrorPlugins() {
        return [createCustomDocumentContentPlugin()];
    },
});

export default CustomDocument;
